exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1UUMy{padding:32px 16px;padding:2rem 1rem;background:#6eb658;color:#fff}._1UUMy p{max-width:500px}._3dfAC{margin:0 auto;max-width:1000px}._1Fa0s{font-weight:500}._3qHjF{padding:4px 0}._3qHjF,._3qHjF:active,._3qHjF:visited{color:#fff;text-decoration:none}._3qHjF:hover{color:#fff}._2HM2Q{margin-top:32px;margin-top:2rem;padding:32px;padding:2rem;max-width:300px;background-color:#fff}@media screen and (min-width:768px){._2HM2Q{margin-top:0;float:right}}._30o6_{margin-left:-16px;margin-left:-1rem;margin-right:-16px;margin-right:-1rem;display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex:0 1 auto;flex:0 1 auto;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-ms-flex-wrap:wrap;flex-wrap:wrap}._1EJ-x,._30o6_{-webkit-box-flex:0}._1EJ-x{padding-left:16px;padding-left:1rem;padding-right:16px;padding-right:1rem;-ms-flex:0 0 auto;flex:0 0 auto;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;width:100%;max-width:100%}@media screen and (min-width:768px){._1EJ-x{-ms-flex-preferred-size:50%;flex-basis:50%;max-width:50%}}", ""]);

// exports
exports.locals = {
	"root": "_1UUMy",
	"container": "_3dfAC",
	"lead": "_1Fa0s",
	"link": "_3qHjF",
	"li": "_2HM2Q",
	"row": "_30o6_",
	"col": "_1EJ-x"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":{"discardComments":{"removeAll":true}}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/components/Footer/Footer.css
// module id = 659
// module chunks = 0 1 2 3 4